import React, { Component } from "react";

class TooManyAttempts extends Component {
  render() {
    const { timer, onTryAgain, styles } = this.props;

    const minutes = Math.floor(timer / 60);
    const seconds = timer % 60;

    return (
      <div className={`${styles.email_otp} ${styles.email_otp__too_many_attempts}`}>
        <div className={styles.email_otp__content}>
          <div className={styles.email_otp__hero}>
            <div className={styles.email_otp__hero_icon}>
              <img src="images/clock_golden.svg" alt="clock" />
            </div>
            <p className={styles.email_otp__title}>Too many attempts</p>
            <p className={styles.email_otp__subtitle}>
              Try after 15 minutes.
            </p>
          </div>

          <div className={styles.email_otp__timer_container}>
            <div className={styles.email_otp__timer_wrapper}>
              <div className={styles.email_otp__timer_box}>
                <p className={styles.email_otp__timer_value}>{minutes}</p>
                <p className={styles.email_otp__timer_label}>Minutes</p>
              </div>

              <div className={styles.email_otp__timer_separator}>:</div>

              <div className={styles.email_otp__timer_box}>
                <p className={styles.email_otp__timer_value}>
                  {seconds < 10 ? `0${seconds}` : seconds}
                </p>
                <p className={styles.email_otp__timer_label}>Seconds</p>
              </div>
            </div>

            <div className={styles.email_otp__submit_container}>
              <button
                className={styles.email_otp__submit_btn}
                onClick={onTryAgain}
                disabled={timer > 0}
              >
                Try Again
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


export default TooManyAttempts;
